import script from "./IDEA_COMMENTS.vue?vue&type=script&setup=true&lang=ts"
export * from "./IDEA_COMMENTS.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__